import React, { ReactNode } from "react";
import { gql, useQuery } from "@apollo/client";
import AutopilotContext, {
  IAutopilotContext,
} from "../../contexts/AutopilotContext";
import { AutopilotProvider_AutopilotPermissionsQuery } from "../../__generated__/graphql";

const AutopilotProvider_AutopilotPermissions = gql`
  query AutopilotProvider_AutopilotPermissions {
    userAccount {
      pk
      org {
        subscription_tier
      }
    }
    permissions {
      maxNumberContactsPerAutopilotSearch
    }
  }
`;

export const AutopilotProvider = ({ children }: { children: ReactNode }) => {
  const {
    data: autopilotPermissionsData,
    loading: autopilotPermissionsLoading,
  } = useQuery<AutopilotProvider_AutopilotPermissionsQuery>(
    AutopilotProvider_AutopilotPermissions,
  );

  const autopilotContextValue: IAutopilotContext = {
    maxNumberContactsPerAutopilotSearch:
      autopilotPermissionsData?.permissions
        ?.maxNumberContactsPerAutopilotSearch || null,
    maxNumberContactsPerAutopilotSearchLoading: autopilotPermissionsLoading,
    subscriptionTier:
      autopilotPermissionsData?.userAccount?.org?.subscription_tier || null,
  };

  return (
    <AutopilotContext.Provider value={autopilotContextValue}>
      {children}
    </AutopilotContext.Provider>
  );
};
